// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3supO","notAuthorizedBadge":"styles_notAuthorizedBadge__1UBi3","backBtn":"styles_backBtn__1oSMG"};